export { default as AdPrice } from "./AdPrice";



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdSummary/AdPrice/index.ts